import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";

export default function ClerkAuth({ children }) {
  const navigate = useNavigate();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let stop = false;
    const go = async (n = 0) => {
      try { const c = await (await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clerk/config`)).json(); if (c.enabled) return stop || setCfg(c); } catch {}
      if (!stop && n < 20) setTimeout(() => go(n + 1), 1500);
    };
    go();
    return () => { stop = true; };
  }, []);
  if (!cfg) return null;
  return (
    <ClerkProvider publishableKey={cfg.publishable_key} proxyUrl={cfg.proxy_url || undefined} routerPush={(t) => navigate(t)} routerReplace={(t) => navigate(t, { replace: true })}
      signInUrl="/sign-in" signUpUrl="/sign-up" signInFallbackRedirectUrl="/account" afterSignOutUrl="/"
      appearance={{ variables: { colorPrimary: "#4A2732", colorBackground: "#F4EFE7", fontFamily: "'Familjen Grotesk', sans-serif", borderRadius: "0" } }}>
      {children}
    </ClerkProvider>
  );
}
